GP.GPMod('SilverUpgrade',function(self) {
    var vent  = null;
    var _util = null;
    var _log  = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;

            // detect the File API (necessary for progressbar on upload)
            data.can_show_progress = !!(window.File && window.FileList);

            // if we're in FF, make sure its FF4+
            if ('MozAppearance' in document.documentElement.style && data.can_show_progress) {
                data.can_show_progress = !!(window.FormData && window.URL);
            }

            if (typeof self_profile_view != 'undefined') {
                if (self_profile_view) {
                    data.add_pic_to_profile = true;
                }
            }
        },
        event_namespace:     'silverpicupload',
        can_show_progress:   false,
        add_pic_to_profile:  false,
        media_type:         'image',
        selected_media_item: null,
        secondary_color_rgb: 'rgb(189, 16, 11)', // default fling color
        filenames: []
    };

    var apis = {
        delete_content: function($clicked) {
            var $add_media_item = $clicked.closest('.add-media-item');
            var content_type = $add_media_item.data('content_type');

            var api_url = '',
                input   = {};

            if (content_type == 'image') {
                api_url = _util.clean_url('members/content/del_content');
                input = {
                    content_id: $add_media_item.data('content_id')
                };
            }

            self.api.json(api_url, {
                type: 'POST',
                data: input
            }).done(function(json) {
                if (content_type == 'image') {
                    $clicked
                        .addClass('hide')
                        .siblings('.img-preview')
                        .css('background-image', 'none')
                        .siblings('.btn-media-add')
                        .removeClass('hide');
                }
                $add_media_item.find('.btn-media-add').removeClass('hide');
                $add_media_item.removeClass('has-media');

            }).fail(function() {
                // error msg?
            });
        }
    };

    var events = {
        // guidlines for uploading pictures
        show_upload_guidlines: function() {
            var url = '/members/info/upload_guidelines&no_header=1';
            var new_window = window.open(url, 'name', 'height=750,width=470,scrollbars=1');
            if (window.focus && new_window) {
                new_window.focus();
            }
            return false;
        },
        // guidlines for usernames
        show_username_guidlines: function() {
            var url = '/members/info/username_guidelines&no_header=1';
            var new_window = window.open(url, 'name', 'height=750,width=470,scrollbars=1');
            if (window.focus && new_window) {
                new_window.focus();
            }
            return false;
        },
        setup_pic_upload: function() {
            data.init();

            var primary_el = document.querySelector('.btn-primary');
            if (primary_el) {
                data.secondary_color_rgb = getComputedStyle(primary_el).getPropertyValue("background-color");
            }

            // add process hidden input to form (since the file upload isn't really ajax)
            $('<input/>').attr({
                type: 'hidden',
                name: 'process',
                value: 'true'
            }).prependTo("#silver-upload-pic-form");

 
            if (window.can_upload_file) {
                // file uploader (blueimp fileupload)
                $('#silver_pic_file_input').fileupload({
                    url: '/members/user/upload_pic/',
                    dataType:         'json',
                    type:             'POST',
                    autoUpload:       true,
                    progressInterval: 50, // default 100ms
                    bitrateInterval:  200,
                    drop: function (e, upload_data) {
                        // set dat.selected_media_item to the first .add-media-item without a pic/video preview
                        data.selected_media_item = $('.js-add-pic:not(".has-media"):first');
                    },
                    add: function(e, upload_data) {
                        // console.log('add hook called... e: ', e);
                        // console.log('add hook called... upload_data: ', upload_data);

                        if (handlers.validate_upload(upload_data)) {
                            window._gp_pic_uploading = true;
                            data.selected_media_item.addClass('active');
                            upload_data.submit();
                        }
                    },
                    start: function(e) {
                        $('.error_container, .success_container').hide();
                        if (data.can_show_progress) {
                            data.selected_media_item.find('.circle-progress-wrap').circleProgress({
                                value: 0,
                                size: 50,
                                fill: {
                                  color: data.secondary_color_rgb
                                }
                            });
                        }
                        $('.notice_container').show();
                    },
                    progress: function(e, json) {
                        var progress = parseInt(json.loaded / json.total * 100, 10);

                        if (data.can_show_progress) {
                            // fix for firefox bug never reporting > 94% progress
                            if (progress > 94) {
                                progress = 100;
                            }
                            // $('#upload_progress .progress-bar').css('width', progress + '%');
                            var $_circle_loader = data.selected_media_item.find('.circle-progress-wrap');
                            $_circle_loader.circleProgress({
                                value: json.loaded / json.total,
                            });
                        }
                    },
                    done: function(e, json) {
                        // console.log('done callback... json.result: ', json.result);

                        // $('.notice_container').hide();
                        $('.errors-wrap').hide();
                        if (!json || !json.hasOwnProperty('textStatus') || json.textStatus != 'success' || !json.result) {
                            // xhr error
                            data.selected_media_item.removeClass('active');
                            $('.errors-wrap p').remove();
                            $('.errors-wrap').append('<p class="error">'+_upload_opts.error_messages[100]+'</p>').show();
                        } else if (json.result[0] && json.result[0].hasOwnProperty('error')) {
                            // some other error coming back from image upload backend
                            data.selected_media_item.removeClass('active');
                            $('.errors-wrap p').remove();
                            $('.errors-wrap').append('<p class="error">'+json.result[0].error+'</p>').show();
                        } else {
                            // success
                            var $modal = self.app.Modal.get_modal();
                            var silver_modal = false;

                            $('.success_container').show();
                            setTimeout(function() {
                                $('.success_container').hide();
                                $('.pic-wrap').addClass('upload-complete');
                            }, 3500);

                            $('.upload-done-button').removeClass('hide');

                            if (data.media_type == 'image') {
                                handlers.show_image_preview(json.result[0].url, json.result[0].content_id);
                            }

                            $.each(json.result, function(index, obj) {
                                if (obj.hasOwnProperty('error')) {
                                    $('.errors-wrap p').remove();
                                    $('.errors-wrap').append('<p class="error">'+obj.error+'</p>').show();
                                } else {

                                    // TODO: check if needed
                                    // if ($modal.hasClass('js-silver-upgrade')) {
                                    //     handlers.add_thumb_to_silver_upgrade(obj);
                                    // }


                                    if (obj.membership_change) {
                                        GP.sdata.my_user.membership = obj.membership_change;
                                        vent.trigger('MessagePane:reset');
                                    }
                                }
                            });
                        }
                        window._gp_pic_uploading = false;
                    }
                });
            } else {
                $('#silver_pic_file_input').click(function(e) {
                    e.preventDefault();
                    alert(js_lang.no_file_upload);
                });
            }


            $('.js-add-pic').on('click.'+data.event_namespace, function(e) {

                if ($(this).hasClass('has-media')) {
                    return;
                }

                $('#silver_pic_file_input').trigger('click');
                $('.add-media-item').removeClass('active');
                data.selected_media_item = $(this);
            });

            $('.btn-media-del').on('click.'+data.event_namespace, function(e) {
                apis.delete_content($(this));
            });
        }
    };


    var handlers = {
        add_thumb_to_silver_upgrade: function(json) {
            if (typeof json.tags != 'undefined' && $.isArray(json.tags)) {
                if ($.inArray('PRIVATE', json.tags) >= 0) {
                    return false;
                }
            }
            // browser will sometimes cache pics when uploading & deleting & show the wrong pic, rand prevents that
            var rand = Math.floor((Math.random()*1000)+1);

            // get the first unused pic space, first selector is so we dont pick up the templates
            var $tmp_pic = $('<img/>')
                .attr('src', _modal_vars.media_url + json.S)
                .attr('id', 'user-pic-' + json.content_id)
                .addClass('pic');
            var $pic_wrap = $('<div/>').addClass('pic').html($tmp_pic);

            $('.user-pic-s .add-pic').parent('.user-pic-s').first().html($pic_wrap);
            $('#photo-check').attr('class', 'success');
        },
        add_thumb_to_profile: function(json) {
            // only add pic to profile, if the user is viewing their own profile
            if (data.add_pic_to_profile) {
                // browser will sometimes cache pics when uploading & deleting & show the wrong pic, rand prevents that
                var rand = Math.floor((Math.random()*1000)+1);
                var href = "/members/user/profile/?type=profile&duid=" + user_duid + "&mid=" + json.pic_order;

                var $template = $('#clone-templates .profile-photo-wrap').clone();
                    $template.find('.profile-photo img').attr('src', _modal_vars.media_url + json.L);
                    $template.find('.profile-photo a').attr('href', href);
                    $template.find('.dropdown li a').data('picnum', json.pic_num);

                // Update profile content collection
                vent.trigger("Content:update_profile_feed", json);
            }
        },
        validate_upload: function(json) {
            // console.log('validate_upload json: ', json);
            var errors = '';
            if (!handlers.check_file_type(json)) {
                if (json.files.length && json.files[0]) {
                    // validate filetype
                    if (json.files.length && json.files[0].name) {
                        var extension = json.files[0].name.split('.').pop().toLowerCase();
                        match = false;
                        $.each(_upload_opts.allowed_filetypes, function(ext, mimetype) {
                            if (ext == extension) {
                                match = true;
                                return true; // break out of .each
                            }
                        });
                        if (!match) {
                            errors += '<p class="error">'+_upload_opts.error_messages[102]+'</p>';
                        }
                    }
                    // validate filesize
                    if (typeof json.files[0].size != 'undefined') {
                        if (json.files[0].size === 0) {
                            errors += '<p class="error">'+_upload_opts.error_messages[104]+'</p>';
                        } else if (json.files[0].size > _upload_opts.max_filesize) {
                            errors += '<p class="error">'+_upload_opts.error_messages[1]+'</p>';
                        }
                    }
                } else {
                    errors += '<p class="error">'+_upload_opts.error_messages[7]+'</p>';
                }
            }

            // check for duplicate filenames
            if (json.files[0].name) {
                var _filename = json.files[0].name;
                if (data.filenames.length === 0) {
                    data.filenames.push(_filename);
                } else {
                    $.each(data.filenames, function(index, _fname) {
                        if (_filename === _fname) {
                            errors += '<p class="error">'+_upload_opts.error_messages[9]+'</p>';
                            return true;
                        }
                    });
                    data.filenames.push(_filename);
                }
            }


            // show/hide error container
            var error_container = $('.errors-wrap');
            if (errors) {
                if (error_container.is(':hidden')) {
                    error_container.show();
                }
                error_container.find('p.error').remove();
                error_container.append(errors);
                return false;
            } else {
                error_container.find('p.error').remove();
                error_container.hide();
                return true;
            }
        },
        check_file_type: function(json) {
            // var file_input = $('#content-file-input')[0].files[0],
            var file_input = json.files[0],
                image_types = /^image\/(gif|jpe?g|png|bmp)$/i,

                // This is for IE<10 because file mimetypes isn't defined in the file data
                image_names = /\.(gif|jpe?g|png|bmp)$/i;

            if ((typeof(file_input.type) !== 'undefined' && image_types.test(file_input.type)) ||
                (typeof(file_input.name) !== 'undefined' && image_names.test(file_input.name))) {
                data.media_type = 'image';
                return true;
            } else {
                // events.show_post_error(js_lang.unacceptable_file_type);
            }

            return false;
        },
        show_image_preview: function(_url, _content_id) {
            data.selected_media_item.find('.img-preview').css('background-image', 'url(' + _url + ')');
            data.selected_media_item.removeClass('active')
            .attr('data-content_id', _content_id)
            .attr('data-content_type', 'image')
            .addClass('has-media');

            data.selected_media_item = null;

            // show checkmark indicating at least 1 photo has been added.
            $('#photo-check').attr('class', 'success');
        },        
    };

    this.addInitializer(function() {
        data.init();
        self.vent.on(self.moduleName+":setup_pic_upload", events.setup_pic_upload, this);
    });
});
